import { Fragment, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Grid, MenuItem, Select, Slider } from '@mui/material';
import { HexColorPicker } from 'react-colorful';

const sortedFontOptions = [
  'Arial',
  'Comic Sans MS',
  'Courier New',
  'Impact',
  'Geneva',
  'Georgia',
  'Tahoma',
  'Trebuchet MS',
  'Verdana',
  'Logical',
  'Montserrat',
  'Salesforce Sans',
  'Garamond',
  'Sans-Serif',
  'Serif',
  'Times New Roman',
  'Helvetica'
].sort()

const defaultButtonData = {
  text: '',
  color: '#fff',
  backgroundColor: '#5563cd',
  verticalPadding: 10,
  horizontalPadding: 20,
  borderRadius: 4,
  fontSize: 14,
  fontFamily: 'Montserrat',
  url: '',
}

const AddButtonForm = ({ initialButtonData = {}, onChangeButtonData }) => {
  const [buttonData, setButtonData] = useState(initialButtonData);

  useEffect(() => {
    if (initialButtonData) {
      setButtonData(initialButtonData)
    }
  }, [initialButtonData])

  const handleChangeButtonField = (field, value) => {
    const newData = {
      ...buttonData,
      [field]: value
    }
    setButtonData(newData)
    onChangeButtonData && onChangeButtonData(newData)
  }

  return (
    <Grid container columnSpacing={3}>
      <Grid item xs={12} md={6}>
        <label>Previsualización</label>
        <div
          style={{
            height: '200px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <a
            style={{
              padding: `${buttonData.verticalPadding}px ${buttonData.horizontalPadding}px`,
              fontSize: buttonData.fontSize,
              fontFamily: `'${buttonData.fontFamily}'`,
              borderRadius: buttonData.borderRadius,
              textTransform: 'none',
              color: buttonData.color,
              backgroundColor: buttonData.backgroundColor
            }}
          >
            {buttonData.text || 'Texto...'}
          </a>
        </div>
      </Grid>

      <Grid item xs={12} md={6}>
        <Grid container>
          <Grid item xs={12} md={6} sx={{ paddingRight: '8px !important' }}>
            <div className="se-dialog-form">
              <label>Color de texto</label>
              <HexColorPicker
                color={buttonData?.color}
                onChange={(color) => handleChangeButtonField('color', color)}
                style={{ width: '100%', height: 'auto', aspectRatio: 1 }}
              />
              <input
                className="se-input-form _se_button_color"
                type="text"
                style={{ marginTop: 10 }}
                value={buttonData?.color}
                onChange={(e) => handleChangeButtonField('color', e.target.value)}
              />
            </div>
          </Grid>

          <Grid item xs={12} md={6} sx={{ paddingLeft: '8px !important' }}>
            <div className="se-dialog-form">
              <label>Color de fondo</label>
              <HexColorPicker
                color={buttonData?.backgroundColor}
                onChange={(color) => handleChangeButtonField('backgroundColor', color)}
                style={{ width: '100%', height: 'auto', aspectRatio: 1 }}
              />
              <input
                className="se-input-form _se_button_background_color"
                type="text"
                style={{ marginTop: 10 }}
                value={buttonData?.backgroundColor}
                onChange={(e) => handleChangeButtonField('backgroundColor', e.target.value)}
              />
            </div>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={6}>
        <div className="se-dialog-form">
          <label>Texto</label>
          <input
            className="se-input-form _se_button_text"
            type="text"
            placeholder='Texto...'
            value={buttonData.text}
            onChange={(e) => handleChangeButtonField('text', e.target.value)}
          />
        </div>
      </Grid>

      <Grid item xs={12} md={6}>
        <div className="se-dialog-form">
          <label>
            Tamaño vertical
            <span className='preview-data'>{buttonData.verticalPadding}</span>
          </label>
          <Slider
            className="_se_button_vertical_padding"
            min={0}
            max={76}
            valueLabelDisplay='auto'
            value={buttonData.verticalPadding}
            onChange={(e) => handleChangeButtonField('verticalPadding', e.target.value)}
          />
        </div>
      </Grid>

      <Grid item xs={12} md={6}>
        <div className="se-dialog-form">
          <label>Fuente</label>
          <Select
            className="se-input-form _se_button_font_family"
            variant='outlined'
            fullWidth
            size='small'
            style={{ border: '1px solid #dadada', padding: '5.5px' }}
            value={buttonData?.fontFamily}
            onChange={(e) => handleChangeButtonField('fontFamily', e.target.value)}
          >
            {sortedFontOptions.map((elem, i) => (
              <MenuItem key={i} value={elem} style={{ fontFamily: `'${elem}'` }}>{elem}</MenuItem>
            ))}
          </Select>
        </div>
      </Grid>

      <Grid item xs={12} md={6}>
        <div className="se-dialog-form">
          <label>
            Tamaño horizontal
            <span className='preview-data'>{buttonData.horizontalPadding}</span>
          </label>
          <Slider
            className="_se_button_horizontal_padding"
            min={0}
            max={32}
            valueLabelDisplay='auto'
            value={buttonData.horizontalPadding}
            onChange={(e) => handleChangeButtonField('horizontalPadding', e.target.value)}
          />
        </div>
      </Grid>

      <Grid item xs={12} md={6}>
        <div className="se-dialog-form">
          <label>
            Tamaño de fuente
            <span className='preview-data'>{buttonData.fontSize}</span>
          </label>
          <Slider
            className="_se_button_font_size"
            min={8}
            max={32}
            valueLabelDisplay='auto'
            value={buttonData.fontSize}
            onChange={(e) => handleChangeButtonField('fontSize', e.target.value)}
          />
        </div>
      </Grid>

      <Grid item xs={12} md={6}>
        <div className="se-dialog-form">
          <label>
            Radio borde
            <span className='preview-data'>{buttonData.borderRadius}</span>
          </label>
          <Slider
            className="_se_button_border_radius"
            min={0}
            max={42}
            valueLabelDisplay='auto'
            value={buttonData.borderRadius}
            onChange={(e) => handleChangeButtonField('borderRadius', e.target.value)}
          />
        </div>
      </Grid>

      <Grid item xs={12}>
        <div className="se-dialog-form">
          <label>URL</label>
          <input
            className="se-input-form _se_button_url"
            type="text"
            value={buttonData?.url}
            onChange={(e) => handleChangeButtonField('url', e.target.value)}
          />
        </div>
      </Grid>
    </Grid>
  )
};

const rgbToHex = (rgb) => {
  const result = rgb.match(/\d+/g);
  const r = parseInt(result[0]).toString(16).padStart(2, '0');
  const g = parseInt(result[1]).toString(16).padStart(2, '0');
  const b = parseInt(result[2]).toString(16).padStart(2, '0');

  return `#${r}${g}${b}`.toUpperCase();
}

const addButtonPlugin = {
  // @Required
  // plugin name
  name: "addButton",

  // @Required
  // data display
  display: "dialog",

  // @Required
  // add function - It is called only once when the plugin is first run.
  // This function generates HTML to append and register the event.
  // arguments - (core : core object, targetElement : clicked button element)
  add: function (core) {
    // If you are using a module, you must register the module using the "addModule" method.
    core.addModule([window.SUNEDITOR_MODULES.dialog]);

    // @Required
    // Registering a namespace for caching as a plugin name in the context object
    const context = core.context;
    context.addButton = {
      focusElement: null, // @Override // This element has focus when the dialog is opened.
      _buttonAnchor: null,
      textButton: null,
      colorButton: null,
      backgroundColorButton: null,
      verticalPaddingButton: null,
      horizontalPaddingButton: null,
      borderRadiusButton: null,
      fontSizeButton: null,
      fontFamilyButton: null,
      urlButton: null
    };

    /** button dialog */
    let buttonDialog = this.setDialog(core);
    context.addButton.modal = buttonDialog;

    /** button controller */
    let buttonController = this.setController_AddButton(core);
    context.addButton.buttonController = buttonController;

    /** add event listeners */
    buttonDialog?.querySelector("form").addEventListener("submit", this.submit.bind(core));
    buttonController.addEventListener("click", this.onClick_buttonController.bind(core));

    /** append html */
    context.dialog.modal.appendChild(buttonDialog);

    /** append controller */
    context.element.relative.appendChild(buttonController);
  },

  /** dialog */
  setDialog: function (core) {
    const lang = core.lang;
    const dialog = core.util.createElement("div");

    dialog.className = "se-dialog-content se-dialog-add-button";
    dialog.style.display = "none";
    dialog.style.maxWidth = "650px"
    dialog.innerHTML = '';

    const customColorPickerContainer = document.createElement('form');
    customColorPickerContainer.id = 'custom-color-picker';
    customColorPickerContainer.className = 'editor_button';
    dialog.appendChild(customColorPickerContainer);
    const root = createRoot(customColorPickerContainer);
    root.render(
      <Fragment>
        <div className="se-dialog-header">
          <button
            type="button"
            data-command="close"
            className="se-btn se-dialog-close"
            aria-label="Close"
            title='Cerrar'
            dangerouslySetInnerHTML={{ __html: core.icons.cancel }}
          />
          <span className="se-modal-title">
            Insertar botón
          </span>
        </div>

        <div className="se-dialog-body" style={{ maxHeight: 'calc(100vh - 161px)', overflowY: 'auto', padding: '15px 21px 5px 0px' }}>
          <AddButtonForm initialButtonData={defaultButtonData} />
        </div>

        <div className="se-dialog-footer">
          <button type="submit" className="se-btn-primary" title={lang.dialogBox.submitButton}>
            {lang.dialogBox.submitButton}
          </button>
        </div>
      </Fragment>
    )

    return dialog;
  },

  /** modify controller button */
  setController_AddButton: function (core) {
    const lang = core.lang;
    const icons = core.icons;
    const button_btn = core.util.createElement("DIV");

    button_btn.className = "se-controller se-controller-button";
    button_btn.innerHTML = '<div className="button-content">' +
      '<div className="se-btn-group">' +
      '<button type="button" data-command="update" tabindex="-1" className="se-tooltip">' +
      icons.edit +
      '<span className="se-tooltip-inner"><span className="se-tooltip-text">' +
      lang.controller.edit +
      "</span></span>" +
      "</button>" +
      '<button type="button" data-command="delete" tabindex="-1" className="se-tooltip">' +
      icons.delete +
      '<span className="se-tooltip-inner"><span className="se-tooltip-text">' +
      lang.controller.remove +
      "</span></span>" +
      "</button>" +
      "</div>" +
      "</div>";

    return button_btn;
  },

  // @Required, @Override dialog
  // This method is called when the plugin button is clicked.
  // Open the modal window here.
  open: function () {
    this.plugins.dialog.open.call(
      this,
      "addButton",
      "addButton" === this.currentControllerName
    );

    const dialog = this.context?.dialog?.modal?.querySelector('.se-dialog-add-button');
    const contextAddButton = this.context.addButton;
    if (dialog) {
      const root = createRoot(dialog.querySelector('#custom-color-picker').querySelector('.se-dialog-body'));
      root.render(
        <AddButtonForm
          initialButtonData={defaultButtonData}
          onChangeButtonData={(updatedData) => {
            contextAddButton.textButton.value = updatedData.text;
            contextAddButton.colorButton.value = updatedData.color;
            contextAddButton.backgroundColorButton.value = updatedData.backgroundColor;
            contextAddButton.verticalPaddingButton.value = updatedData.verticalPadding;
            contextAddButton.horizontalPaddingButton.value = updatedData.horizontalPadding;
            contextAddButton.borderRadiusButton.value = updatedData.borderRadius;
            contextAddButton.fontSizeButton.value = updatedData.fontSize;
            contextAddButton.fontFamilyButton.value = updatedData.fontFamily;
            contextAddButton.urlButton.value = updatedData.url;
          }}
        />
      );
    }
  },

  submit: function (e) {
    this.showLoading();

    e.preventDefault();
    e.stopPropagation();

    const submitAction = function () {
      if (this.context.addButton.textButton.value.trim().length === 0)
        return false;

      const contextAddButton = this.context.addButton;
      const textButton = contextAddButton.textButton.value;
      const colorButton = contextAddButton.colorButton.value;
      const backgroundColorButton = contextAddButton.backgroundColorButton.value;
      const verticalPaddingButton = contextAddButton.verticalPaddingButton.value;
      const horizontalPaddingButton = contextAddButton.horizontalPaddingButton.value;
      const borderRadiusButton = contextAddButton.borderRadiusButton.value;
      const fontSizeButton = contextAddButton.fontSizeButton.value;
      const fontFamilyButton = contextAddButton.fontFamilyButton.value;
      const urlButton = contextAddButton.urlButton.value;

      if (!this.context.dialog.updateModal) {
        const linkElement = this.util.createElement('a');
        linkElement.href = urlButton;
        linkElement.target = '_blank'

        const buttonElement = this.util.createElement('button');
        buttonElement.textContent = textButton;
        buttonElement.style.padding = `${verticalPaddingButton}px ${horizontalPaddingButton}px`
        buttonElement.style.fontSize = `${fontSizeButton}px`
        buttonElement.style.fontFamily = `'${fontFamilyButton}'`
        buttonElement.style.borderRadius = `${borderRadiusButton}px`
        buttonElement.style.color = colorButton
        buttonElement.style.backgroundColor = backgroundColorButton
        buttonElement.style.border = `none`
        buttonElement.style.textTransform = 'none'
        buttonElement.style.textDecoration = 'none'
        buttonElement.style.lineHeight = 1.1
        buttonElement.style.cursor = 'pointer'
        buttonElement.style.boxShadow = '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'

        linkElement.appendChild(buttonElement)

        const selectedFormats = this.getSelectedElements();
        if (selectedFormats.length > 1) {
          const oFormat = this.util.createElement(selectedFormats[0].nodeName);
          oFormat.appendChild(linkElement);
          this.insertNode(oFormat);
        } else {
          this.insertNode(linkElement);
        }

        const space = document.createTextNode("\u00A0"); // Esto es un espacio no separable (&nbsp;)
        this.insertNode(space);
      } else {
        contextAddButton._buttonAnchor.href = urlButton;

        const buttonElement = contextAddButton._buttonAnchor.querySelector('button');
        buttonElement.textContent = textButton;
        buttonElement.style.padding = `${verticalPaddingButton}px ${horizontalPaddingButton}px`
        buttonElement.style.fontSize = `${fontSizeButton}px`
        buttonElement.style.fontFamily = `'${fontFamilyButton}'`
        buttonElement.style.borderRadius = `${borderRadiusButton}px`
        buttonElement.style.color = colorButton
        buttonElement.style.backgroundColor = backgroundColorButton
      }

      // history stack
      this.history.push(false);
    }.bind(this);

    try {
      submitAction();
    } finally {
      this.plugins.dialog.close.call(this);
      this.closeLoading();
      this.focus();
    }

    return false;
  },

  // @Override core
  // Plugins with active methods load immediately when the editor loads.
  // Called each time the selection is moved.
  active: function (element) {
    if (!element) {
      if (this.controllerArray.indexOf(this.context.addButton.buttonController) > -1) {
        this.controllersOff();
      }
    } else if (this.util.isAnchor(element) && element.getAttribute("data-image-link") === null) {
      if (this.controllerArray.indexOf(this.context.addButton.buttonController) < 0) {
        this.plugins.addButton.call_controller.call(this, element);
      }

      return true;
    }

    return false;
  },

  // @Override dialog
  // This method is called just before the dialog opens.
  // If "update" argument is true, it is not a new call, but a call to modify an already created element.
  on: function (update) {
    const contextAddButton = this.context.addButton
    const dialog = this.context.dialog;
    const modal = dialog.modal
    contextAddButton.textButton = modal?.querySelector("._se_button_text");
    contextAddButton.colorButton = modal?.querySelector("._se_button_color");
    contextAddButton.backgroundColorButton = modal?.querySelector("._se_button_background_color");
    contextAddButton.verticalPaddingButton = modal?.querySelector("._se_button_vertical_padding")?.querySelector('input');
    contextAddButton.horizontalPaddingButton = modal?.querySelector("._se_button_horizontal_padding")?.querySelector('input');
    contextAddButton.borderRadiusButton = modal?.querySelector("._se_button_border_radius")?.querySelector('input');
    contextAddButton.fontSizeButton = modal?.querySelector("._se_button_font_size")?.querySelector('input');
    contextAddButton.fontFamilyButton = modal?.querySelector("._se_button_font_family")?.querySelector('input');
    contextAddButton.urlButton = modal?.querySelector("._se_button_url");

    if (!update) {
      this.plugins.addButton.init.call(this);
    } else if (contextAddButton._buttonAnchor) {
      const button = contextAddButton._buttonAnchor.querySelector("button");
      dialog.updateModal = true;

      const buttonData = {
        text: button.textContent || '',
        color: rgbToHex(button.style.color) || '#fff',
        backgroundColor: rgbToHex(button.style.backgroundColor) || '#5563cd',
        verticalPadding: parseInt(button.style.paddingTop) || 10,
        horizontalPadding: parseInt(button.style.paddingLeft) || 20,
        borderRadius: parseInt(button.style.borderRadius) || 4,
        fontSize: parseInt(button.style.fontSize) || 14,
        fontFamily: button.style.fontFamily?.replace(/['"]/g, '') || 'Montserrat',
        url: contextAddButton._buttonAnchor?.href || ''
      }

      const root = createRoot(dialog.modal?.querySelector('#custom-color-picker').querySelector('.se-dialog-body'));
      root.render(
        <AddButtonForm
          initialButtonData={buttonData}
          onChangeButtonData={(updatedData) => {
            contextAddButton.textButton.value = updatedData.text;
            contextAddButton.colorButton.value = updatedData.color;
            contextAddButton.backgroundColorButton.value = updatedData.backgroundColor;
            contextAddButton.verticalPaddingButton.value = updatedData.verticalPadding;
            contextAddButton.horizontalPaddingButton.value = updatedData.horizontalPadding;
            contextAddButton.borderRadiusButton.value = updatedData.borderRadius;
            contextAddButton.fontSizeButton.value = updatedData.fontSize;
            contextAddButton.fontFamilyButton.value = updatedData.fontFamily;
            contextAddButton.urlButton.value = updatedData.url;
          }}
        />
      );
    }
  },

  call_controller: function (selectionATag) {
    this.context.addButton._buttonAnchor = selectionATag;
    const buttonElement = selectionATag.querySelector('button')
    const buttonController = this.context.addButton.buttonController;
    if (buttonElement && buttonController) {
      const offset = this.util.getOffset(buttonElement, this.context.element.wysiwygFrame);
      buttonController.style.top = offset.top + buttonElement.offsetHeight + 10 + "px";
      buttonController.style.left = offset.left - this.context.element.wysiwygFrame.scrollLeft + "px";
      buttonController.style.display = "block";
  
      const overLeft = this.context.element.wysiwygFrame.offsetWidth - (buttonController.offsetLeft + buttonController.offsetWidth);
      if (overLeft < 0) {
        buttonController.style.left = buttonController.offsetLeft + overLeft + "px";
        buttonController.firstElementChild.style.left = 20 - overLeft + "px";
      } else {
        buttonController.firstElementChild.style.left = "20px";
      }
  
      // Show controller at editor area (controller elements, function, "controller target element(@Required)", "controller name(@Required)", etc..)
      this.controllersOn(buttonController, buttonElement, "addButton");
    }
  },

  onClick_buttonController: function (e) {
    e.stopPropagation();

    const command = e.target.getAttribute("data-command");
    if (!command) return;

    e.preventDefault();

    if (/update/.test(command)) {
      this.plugins.dialog.open.call(this, "addButton", true);
    } else if (/delete/.test(command)) {
      this.util.removeItem(this.context.addButton._buttonAnchor);
      this.context.addButton._buttonAnchor = null;
      this.focus();

      // history stack
      this.history.push(false);
    }

    this.controllersOff();
  },

  // @Required, @Override dialog
  // This method is called when the dialog window is closed.
  // Initialize the properties.
  init: function () {
    const contextAddButton = this.context.addButton;
    contextAddButton.buttonController.style.display = 'none'
  }
};

export default addButtonPlugin;